// extracted by mini-css-extract-plugin
module.exports = {"email-modal":"report-modal_email-modal__qSs5t","address-header":"report-modal_address-header__3kUOF","report-email":"report-modal_report-email__1iVSg"};